import { Empty } from 'antd';

import { useTranslate } from 'hooks';

export const EmptyComponent = () => {
	const { noDataText } = useTranslate(['noDataText']);

	return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={noDataText} />;
};
